import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import Navigation from "@/components/Navigation";
import CosmicHero from "@/components/CosmicHero";
import BlueprintGenerator from "@/components/BlueprintGenerator";
import WisdomSection from "@/components/WisdomSection";
import AboutSection from "@/components/AboutSection";
import ServicesSection from "@/components/ServicesSection";
import FaqSection from "@/components/FaqSection";
import Footer from "@/components/Footer";
import PaymentStatus from "@/components/PaymentStatus";

import AdminLogin from "@/admin/AdminLogin";
import AdminLayout from "@/admin/AdminLayout";
import AdminOverview from "@/admin/AdminOverview";
import AdminClients from "@/admin/AdminClients";
import AdminAvailability from "@/admin/AdminAvailability";
import AdminTransactions from "@/admin/AdminTransactions";
import AdminSettings from "@/admin/AdminSettings";

import { trackPageview, trackEvent } from "@/lib/analytics";

const Home = () => {
  const scrollToBlueprint = () => {
    trackEvent("cta_hero_clicked");
    const el = document.getElementById("blueprint");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <main data-testid="home-page">
      <Navigation />
      <CosmicHero onCTAClick={scrollToBlueprint} />
      <BlueprintGenerator />
      <WisdomSection />
      <AboutSection />
      <ServicesSection />
      <FaqSection />
      <Footer />
      <PaymentStatus />
    </main>
  );
};

// Tracks one pageview per route change (skips /admin routes — they are private).
const RouteTracker = () => {
  const location = useLocation();
  useEffect(() => {
    if (!location.pathname.startsWith("/admin")) {
      trackPageview(location.pathname);
    }
  }, [location.pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <Toaster
        theme="dark"
        position="top-center"
        toastOptions={{
          className: "font-sans",
          style: {
            background: "#0B0E14",
            color: "#F8FAFC",
            border: "1px solid rgba(212,175,55,0.25)",
          },
        }}
      />
      <BrowserRouter>
        <RouteTracker />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminOverview />} />
            <Route path="transactions" element={<AdminTransactions />} />
            <Route path="clients" element={<AdminClients />} />
            <Route path="availability" element={<AdminAvailability />} />
            <Route path="settings" element={<AdminSettings />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
